import ApiClient from './api-client';

const FeatureManager = {
	_subscriptionCache: null,
	_cacheTimestamp: 0,
	_cacheTTL: 60000,

	async _fetchSubscription() {
		const now = Date.now();
		if (
			this._subscriptionCache &&
			now - this._cacheTimestamp < this._cacheTTL
		) {
			console.debug('[FeatureManager] Cache HIT');
			return this._subscriptionCache;
		}

		console.debug('[FeatureManager] Cache MISS');

		try {
			const result = await ApiClient.bffGet('/v1/subscriptions/status', {
				requiresAuth: true,
			});

			if (!result.success) {
				console.error(
					'[FeatureManager] BFF request failed - Error:',
					result.error,
				);
				return null;
			}

			const data = result.data;
			this._subscriptionCache = data;
			this._cacheTimestamp = now;
			return data;
		} catch (error) {
			console.error('[FeatureManager] BFF request failed - Error:', error);
			return null;
		}
	},

	async has(featureName) {
		const subscription = await this._fetchSubscription();

		if (!subscription || !Array.isArray(subscription.features)) {
			return false;
		}

		return subscription.features.some(feature => feature.slug === featureName);
	},

	async getAll() {
		const subscription = await this._fetchSubscription();

		if (!subscription || !Array.isArray(subscription.features)) {
			return [];
		}

		return subscription.features.map(feature => feature.slug);
	},

	async hasActiveSubscription() {
		const subscription = await this._fetchSubscription();
		return subscription?.status === 'ACTIVE';
	},

	clearCache() {
		this._subscriptionCache = null;
		this._cacheTimestamp = 0;
		console.debug('[FeatureManager] Cache cleared');
	},
};

export default FeatureManager;
